import defineWellKnownSymbol$1 from '../internals/define-well-known-symbol.js';

var defineWellKnownSymbol = defineWellKnownSymbol$1; // `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive

defineWellKnownSymbol('toPrimitive');
